/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Divider } from '@material-ui/core';
import {
  Header,
  NoFavoritesRecent,
  FavoriteRecentList,
  ManageFavoriteRecent,
} from '../../components';

class Recents extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  showHeader = () => {
    const { editListInprogress, t, list } = this.props;
    const favRecent = title => <Header title={title} />;
    let showFavRecent = null;
    if (editListInprogress) {
      showFavRecent = favRecent(t('recent.label.manage-recents'));
    } else {
      showFavRecent = favRecent(`${t('recent.label.title')} (${list.length})`);
    }
    return showFavRecent;
  };

  showFavRecentList = () => {
    const { editListInprogress, list } = this.props;
    let showList = null;
    if (!editListInprogress && list.length > 0) {
      showList = <FavoriteRecentList />;
    } else if (editListInprogress && list.length > 0) {
      showList = <ManageFavoriteRecent />;
    }
    return showList;
  };

  render() {
    return (
      <React.Fragment>
        {this.showHeader()}
        <Divider />
        {this.showFavRecentList()}
        <NoFavoritesRecent />
      </React.Fragment>
    );
  }
}

Recents.propTypes = {
  t: PropTypes.func.isRequired,
  list: PropTypes.array,
  editListInprogress: PropTypes.bool.isRequired,
};

Recents.defaultProps = {
  list: [],
};

const mapStateToProps = ({ poi }) => ({
  list: poi.favorite_recent_list,
  editListInprogress: poi.edit_list_inprogress,
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Recents));
